import { ChangeDetectionStrategy, Component, ContentChild, TemplateRef } from '@angular/core'

@Component({
	selector: 'app-table-actions',
	templateUrl: 'table-actions.component.html',
	styleUrl: 'table-actions.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableActionsComponent {
	@ContentChild(TemplateRef) actionsTemplate: TemplateRef<unknown> | null = null
}
